import { LOAD_ALL_CENTER, LOAD_SINGLE_CENTER } from "./CenterList.saga";

export const loadAllCenter = (payload) => ({
  type: LOAD_ALL_CENTER.LOADING,
  payload,
});

export const loadSingleCenter = (payload) => ({
  type: LOAD_SINGLE_CENTER.LOADING,
  payload,
});
